// extracted by mini-css-extract-plugin
export default {"messageContainer":"e8f3756adb23949228004f2ead341e6c-scss","icon":"_82444a36f77c88a9e887a2e1bd142e6d-scss","message":"_9447a7ad461bed229b33a4f002a97de1-scss"};